import Highlighter from './highlighter'

export default Highlighter
